const catalogFungicides = [
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Abacus HC',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Basf',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.strobilurin',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.pyraclostrobin',
        active_ingredient_concentration: 260,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.epoxiconazole',
        active_ingredient_concentration: 160,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.25,
          dosis_max: 0.3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.25,
          dosis_max: 0.3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.25,
          dosis_max: 0.3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_target_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.25,
          dosis_max: 0.3,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Absoluto 500 SC',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Iharabras',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 530,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.isophthalonitrile',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.chlorothalonil',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2,
          dosis_max: 3,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Absoluto FIX',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Iharabras',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 728,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.isophthalonitrile',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.chlorothalonil',
        active_ingredient_concentration: 720,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 1.4,
          dosis_max: 1.8,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 1.5,
          dosis_max: 2,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Across',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Adama',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 729,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.isophthalonitrile',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.chlorothalonil',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.strobilurin',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.azoxystrobin',
        active_ingredient_concentration: 40,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.difenoconazole',
        active_ingredient_concentration: 40,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_anthracnosis',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 1.75,
          dosis_max: 2,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2,
          dosis_max: 2.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 1.5,
          dosis_max: 2,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 1.75,
          dosis_max: 2,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 1.5,
          dosis_max: 2,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_target_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2,
          dosis_max: 2.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Adante Xtra',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Syngenta',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 582,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.others',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.others',
        active_ingredient_concentration: 182,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.strobilurin',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.azoxystrobin',
        active_ingredient_concentration: 242,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.cyproconazole',
        active_ingredient_concentration: 96,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.25,
          dosis_max: 0.33,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Aderis',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Ouro Fino Qu\u00edmica',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 571,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.isophthalonitrile',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.chlorothalonil',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2,
          dosis_max: 3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2,
          dosis_max: 3,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Agata',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'ISK Biosciences',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 816,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.phenylpyridinylamine',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.fluazinam',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_white_mold',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.75,
          dosis_max: 1,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Agroben 500',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Agroimport do Brasil',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 12,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.benzimidazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.carbendazim',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Agrotop',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Pilarquim BR Comercial',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.emulsifiable_concentrate_ec',
    pesticide_id: 940,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.difenoconazole',
        active_ingredient_concentration: 250,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.15,
          dosis_max: 0.2,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_target_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.15,
          dosis_max: 0.2,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'AgTecmmon',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Massen Produtos Biologicos',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 862,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_amyloliquefaciens',
        active_ingredient_concentration: 473.5,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_anthracnosis',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.75,
          dosis_max: 1,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_target_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 1,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_white_mold',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.75,
          dosis_max: 1,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Airone Inox',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Isagro Brasil Comercio de Produtos Agroqu\u00edmicos',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 581,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.inorganic',
        mode_of_action:
          'pesticide_mode_of_action.inorganic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.copper_oxychloride',
        active_ingredient_concentration: 239.4,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.others',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.others',
        active_ingredient_concentration: 223,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2,
          dosis_max: 4,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 1,
          dosis_max: 3,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Airone Scudo',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Isagro Brasil Comercio de Produtos Agroqu\u00edmicos',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 675,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.inorganic',
        mode_of_action:
          'pesticide_mode_of_action.inorganic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.copper_oxychloride',
        active_ingredient_concentration: 239.4,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.others',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.others',
        active_ingredient_concentration: 223,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2,
          dosis_max: 4,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 1,
          dosis_max: 3,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Alade',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Syngenta',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.emulsifiable_concentrate_ec',
    pesticide_id: 730,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.carboxamide',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.benzovindiflupyr',
        active_ingredient_concentration: 60,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.cyproconazole',
        active_ingredient_concentration: 90,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.difenoconazole',
        active_ingredient_concentration: 150,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_anthracnosis',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.35,
          dosis_max: 0.75,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.35,
          dosis_max: 0.75,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.35,
          dosis_max: 0.75,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.35,
          dosis_max: 0.75,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.35,
          dosis_max: 0.75,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_target_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.35,
          dosis_max: 0.75,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: '\u00c1libi',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Syngenta',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 533,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.strobilurin',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.azoxystrobin',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.difenoconazole',
        active_ingredient_concentration: 125,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.3,
          dosis_max: 0.3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.3,
          dosis_max: 0.3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.3,
          dosis_max: 0.3,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Almada',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Adama',
    pesticide_unit: 'product_unit_measure.l',
    formulation:
      'pesticide_formulation.oil_dispersion_or_oil_concentrated_suspension_od',
    pesticide_id: 999,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.carboxamide',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.fluxapyroxad',
        active_ingredient_concentration: 22.5,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.dithiocarbamate',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.mancozeb',
        active_ingredient_concentration: 440,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazolinthione',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.prothioconazole',
        active_ingredient_concentration: 31.5,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_anthracnosis',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2.25,
          dosis_max: 2.25,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2,
          dosis_max: 2,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2.25,
          dosis_max: 2.25,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2.25,
          dosis_max: 2.25,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2.25,
          dosis_max: 2.25,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_target_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2.25,
          dosis_max: 2.25,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Alterne',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Adama',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.emulsifiable_concentrate_ec',
    pesticide_id: 15,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.tebuconazole',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.75,
          dosis_max: 0.75,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.75,
          dosis_max: 0.75,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Altima',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'ISK Biosciences',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 817,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.phenylpyridinylamine',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.fluazinam',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_white_mold',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.75,
          dosis_max: 1,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Amylo-X SL',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Mitsui & Co',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.soluble_concentrate_sl',
    pesticide_id: 863,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_amyloliquefaciens',
        active_ingredient_concentration: 988.5,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_white_mold',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 1,
          dosis_max: 2,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Apollo 500 SC',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Tide do Brasil',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 23,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.benzimidazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.carbendazim',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Approve',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Iharabras',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.dispersible_granules_wg',
    pesticide_id: 24,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.benzimidazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.thiophanate_methyl',
        active_ingredient_concentration: 375,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
      {
        chemical_group: 'chemical_group.phenylpyridinylamine',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.fluazinam',
        active_ingredient_concentration: 375,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_anthracnosis',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 1,
          dosis_max: 1,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 0.6,
          dosis_max: 1,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 0.6,
          dosis_max: 1,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_target_spot',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 1,
          dosis_max: 1,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_white_mold',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 1,
          dosis_max: 1,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Aproach Power',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Corteva',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.emulsifiable_concentrate_ec',
    pesticide_id: 731,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.strobilurin',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.picoxystrobin',
        active_ingredient_concentration: 90,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.cyproconazole',
        active_ingredient_concentration: 40,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.6,
          dosis_max: 1,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.6,
          dosis_max: 0.6,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.6,
          dosis_max: 0.6,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.6,
          dosis_max: 0.6,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Aproach Premium',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Oxiqu\u00edmica Agroci\u00eancia',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1145,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.inorganic',
        mode_of_action:
          'pesticide_mode_of_action.inorganic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.copper_oxychloride',
        active_ingredient_concentration: 420,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.strobilurin',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.picoxystrobin',
        active_ingredient_concentration: 60,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.cyproconazole',
        active_ingredient_concentration: 40,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.7,
          dosis_max: 1.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Aproach Prima',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Corteva',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 25,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.strobilurin',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.picoxystrobin',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.cyproconazole',
        active_ingredient_concentration: 80,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.3,
          dosis_max: 0.3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.3,
          dosis_max: 0.3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.3,
          dosis_max: 0.3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.3,
          dosis_max: 0.3,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Arcadia',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Adama',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 27,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.strobilurin',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.kresoxim_methyl',
        active_ingredient_concentration: 100,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.tebuconazole',
        active_ingredient_concentration: 125,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 1,
          dosis_max: 1,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 1,
          dosis_max: 1,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Armero',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Adama',
    pesticide_unit: 'product_unit_measure.l',
    formulation:
      'pesticide_formulation.oil_dispersion_or_oil_concentrated_suspension_od',
    pesticide_id: 809,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.dithiocarbamate',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.mancozeb',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazolinthione',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.prothioconazole',
        active_ingredient_concentration: 40,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2,
          dosis_max: 2.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2,
          dosis_max: 2.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_target_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2,
          dosis_max: 2.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Array 200 EC',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Albaugh Agro',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.emulsifiable_concentrate_ec',
    pesticide_id: 29,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.tebuconazole',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.75,
          dosis_max: 0.75,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.75,
          dosis_max: 0.75,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Asgard 500 SC',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Crystal Agro',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 864,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.phenylpyridinylamine',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.fluazinam',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_white_mold',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.75,
          dosis_max: 1,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Atak',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Prentiss Qu\u00edmica',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.emulsifiable_concentrate_ec',
    pesticide_id: 559,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.tebuconazole',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.75,
          dosis_max: 0.75,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.75,
          dosis_max: 0.75,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Ativum',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Basf',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.emulsifiable_concentrate_ec',
    pesticide_id: 33,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.carboxamide',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.fluxapyroxad',
        active_ingredient_concentration: 50,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.strobilurin',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.pyraclostrobin',
        active_ingredient_concentration: 81,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.epoxiconazole',
        active_ingredient_concentration: 50,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_aerial_web_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.8,
          dosis_max: 1,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_anthracnosis',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.8,
          dosis_max: 1,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.8,
          dosis_max: 1,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.8,
          dosis_max: 1,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.8,
          dosis_max: 1,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.8,
          dosis_max: 1,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_target_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.8,
          dosis_max: 1,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Attila',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Bayer',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1030,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.carboxamide',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.fluopyram',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_white_mold',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.3,
          dosis_max: 0.4,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Audaz',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Oxiqu\u00edmica Agroci\u00eancia',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 663,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.carboxamide',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.fluxapyroxad',
        active_ingredient_concentration: 50,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.inorganic',
        mode_of_action:
          'pesticide_mode_of_action.inorganic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.copper_oxychloride',
        active_ingredient_concentration: 420,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.8,
          dosis_max: 1.2,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.8,
          dosis_max: 1.2,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_target_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.8,
          dosis_max: 1.2,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Aumenax',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Basf',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 670,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.carboxamide',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.fluxapyroxad',
        active_ingredient_concentration: 50,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.inorganic',
        mode_of_action:
          'pesticide_mode_of_action.inorganic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.copper_oxychloride',
        active_ingredient_concentration: 420,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.8,
          dosis_max: 1.2,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.8,
          dosis_max: 1.2,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_target_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.8,
          dosis_max: 1.2,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Authority',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'FMC',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 38,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.strobilurin',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.azoxystrobin',
        active_ingredient_concentration: 125,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.flutriafol',
        active_ingredient_concentration: 125,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.6,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Azimut',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Adama',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 40,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.strobilurin',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.azoxystrobin',
        active_ingredient_concentration: 120,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.tebuconazole',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Azimut Supra',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Adama',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.dispersible_granules_wg',
    pesticide_id: 41,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.dithiocarbamate',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.mancozeb',
        active_ingredient_concentration: 600,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
      {
        chemical_group: 'chemical_group.strobilurin',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.azoxystrobin',
        active_ingredient_concentration: 40,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.tebuconazole',
        active_ingredient_concentration: 40,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 2,
          dosis_max: 2.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 1.5,
          dosis_max: 2,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_target_spot',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 2,
          dosis_max: 2.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Baktillis',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Mezfer BR Solu\u00e7\u00f5es Agr\u00edcolas',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 865,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_subtilis',
        active_ingredient_concentration: 15,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_white_mold',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2,
          dosis_max: 4,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Band',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Nutrien Solu\u00e7\u00f5es Agr\u00edcolas',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 43,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.flutriafol',
        active_ingredient_concentration: 125,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.8,
          dosis_max: 1,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.4,
          dosis_max: 0.6,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.8,
          dosis_max: 1,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Banjo',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Adama',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 820,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.phenylpyridinylamine',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.fluazinam',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_white_mold',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.75,
          dosis_max: 1,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Battle',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'FMC',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 47,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.benzimidazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.carbendazim',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.flutriafol',
        active_ingredient_concentration: 84,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.6,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.6,
          dosis_max: 0.6,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Belyan',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Basf',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 866,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.carboxamide',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.fluxapyroxad',
        active_ingredient_concentration: 88.9,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.strobilurin',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.pyraclostrobin',
        active_ingredient_concentration: 177.8,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.mefentrifluconazole',
        active_ingredient_concentration: 133.3,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_anthracnosis',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.6,
          dosis_max: 0.8,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.7,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.6,
          dosis_max: 0.7,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.6,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.6,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_target_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.6,
          dosis_max: 0.7,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Bendazol',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Adama',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 53,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.benzimidazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.carbendazim',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Biagro Solo',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Simbiose',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 867,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.trichoderma_harzianum',
        active_ingredient_concentration: 5,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_white_mold',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 1.5,
          dosis_max: 2.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Bio-Imune',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Vittia',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 748,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_velezensis',
        active_ingredient_concentration: 42,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_anthracnosis',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 2,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 2,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_target_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 2,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_white_mold',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 4,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Blavity',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Basf',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 732,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.carboxamide',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.fluxapyroxad',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazolinthione',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.prothioconazole',
        active_ingredient_concentration: 280,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_aerial_web_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.25,
          dosis_max: 0.3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_anthracnosis',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.25,
          dosis_max: 0.3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.25,
          dosis_max: 0.3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.25,
          dosis_max: 0.3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.25,
          dosis_max: 0.3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.25,
          dosis_max: 0.3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_target_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.25,
          dosis_max: 0.3,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Blindado TOV',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Adama',
    pesticide_unit: 'product_unit_measure.l',
    formulation:
      'pesticide_formulation.oil_dispersion_or_oil_concentrated_suspension_od',
    pesticide_id: 1126,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.dithiocarbamate',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.mancozeb',
        active_ingredient_concentration: 400,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.strobilurin',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.picoxystrobin',
        active_ingredient_concentration: 26.66,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.tebuconazole',
        active_ingredient_concentration: 33.33,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2,
          dosis_max: 2.2,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2,
          dosis_max: 2.2,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Bombardeiro',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Total Biotecnologia Industria e Comercio',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 868,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_pumilus',
        active_ingredient_concentration: 33.3,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_subtilis',
        active_ingredient_concentration: 33.3,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_velezensis',
        active_ingredient_concentration: 33.3,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.2,
          dosis_max: 0.4,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Braultra 720 SC',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Nutrien Solu\u00e7\u00f5es Agr\u00edcolas',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 941,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.isophthalonitrile',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.chlorothalonil',
        active_ingredient_concentration: 720,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 1.4,
          dosis_max: 2,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Bravengis',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Oxon Brasil Defensivos Agr\u00edcolas',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 869,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.isophthalonitrile',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.chlorothalonil',
        active_ingredient_concentration: 450,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.tebuconazole',
        active_ingredient_concentration: 50,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2,
          dosis_max: 2.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 1.25,
          dosis_max: 1.75,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Bravonil 500',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Syngenta',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 58,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.isophthalonitrile',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.chlorothalonil',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 1.5,
          dosis_max: 3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 1.5,
          dosis_max: 3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2,
          dosis_max: 3,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Bravonil 720',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Syngenta',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 646,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.isophthalonitrile',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.chlorothalonil',
        active_ingredient_concentration: 720,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 1,
          dosis_max: 2,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 1,
          dosis_max: 2,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 1,
          dosis_max: 2,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Bravonil TOP',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Syngenta',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 870,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.isophthalonitrile',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.chlorothalonil',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.difenoconazole',
        active_ingredient_concentration: 50,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 1.5,
          dosis_max: 2.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Brisa WG',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Sipcam',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.dispersible_granules_wg',
    pesticide_id: 942,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.benzimidazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.thiophanate_methyl',
        active_ingredient_concentration: 240,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
      {
        chemical_group: 'chemical_group.isophthalonitrile',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.chlorothalonil',
        active_ingredient_concentration: 600,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 1.5,
          dosis_max: 2,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Bumper',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Adama',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.emulsifiable_concentrate_ec',
    pesticide_id: 543,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.propiconazole',
        active_ingredient_concentration: 250,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Buran',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Yonon Bioci\u00eancias e Defensivos Agr\u00edcolas',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 566,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.flutriafol',
        active_ingredient_concentration: 125,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.8,
          dosis_max: 1,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.4,
          dosis_max: 0.6,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.8,
          dosis_max: 1,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Buzz',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'SM Agrocare',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.emulsifiable_concentrate_ec',
    pesticide_id: 1140,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.tebuconazole',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.75,
          dosis_max: 0.75,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.75,
          dosis_max: 0.75,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Cadet',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Proregistros Registros de Produtos',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.wettable_powder_wp',
    pesticide_id: 871,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.dithiocarbamate',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.mancozeb',
        active_ingredient_concentration: 800,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 1.4,
          dosis_max: 2.8,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 1.4,
          dosis_max: 2.8,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 1.4,
          dosis_max: 2.8,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_target_spot',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 1.4,
          dosis_max: 2.4,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Capo WG',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Sipcam',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.dispersible_granules_wg',
    pesticide_id: 72,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.benzimidazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.thiophanate_methyl',
        active_ingredient_concentration: 850,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 0.3,
          dosis_max: 0.7,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 0.5,
          dosis_max: 0.7,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 0.3,
          dosis_max: 0.7,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_target_spot',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 0.72,
          dosis_max: 0.72,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_white_mold',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 0.72,
          dosis_max: 0.72,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Caramba 90',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Basf',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.soluble_concentrate_sl',
    pesticide_id: 78,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.metconazole',
        active_ingredient_concentration: 90,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.6,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Caravan',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Koppert do Brasil Holding',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 872,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_pumilus',
        active_ingredient_concentration: 150,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.05,
          dosis_max: 0.4,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.05,
          dosis_max: 0.4,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_target_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.1,
          dosis_max: 0.8,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Carben 500 SC',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Cropchem',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 79,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.benzimidazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.carbendazim',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Carbendazim Crop BR',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Globachem',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 761,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.benzimidazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.carbendazim',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_target_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Carbendazim Nortox',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Nortox',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 82,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.benzimidazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.carbendazim',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_anthracnosis',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.8,
          dosis_max: 1,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.8,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.8,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_target_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.8,
          dosis_max: 1,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_white_mold',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 1,
          dosis_max: 1,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Carbomax 500 SC',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Sumitomo Chemical',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 87,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.benzimidazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.carbendazim',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.4,
          dosis_max: 0.4,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Cercobin 875 WG',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Iharabras',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.dispersible_granules_wg',
    pesticide_id: 531,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.benzimidazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.thiophanate_methyl',
        active_ingredient_concentration: 875,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_target_spot',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 0.7,
          dosis_max: 0.7,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_white_mold',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 0.7,
          dosis_max: 0.7,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Cerconil',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Iharabras',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 676,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.benzimidazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.thiophanate_methyl',
        active_ingredient_concentration: 140,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.isophthalonitrile',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.chlorothalonil',
        active_ingredient_concentration: 350,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 1.5,
          dosis_max: 2,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Cerim\u00f4nia',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Tradecorp do Brasil Com\u00e9rcio de insumos Agr\u00edcolas',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.emulsifiable_concentrate_ec',
    pesticide_id: 873,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.difenoconazole',
        active_ingredient_concentration: 250,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_anthracnosis',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.3,
          dosis_max: 0.3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.15,
          dosis_max: 0.2,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.15,
          dosis_max: 0.2,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Charrua 430 SC',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Cropchem',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 762,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.tebuconazole',
        active_ingredient_concentration: 430,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.23,
          dosis_max: 0.23,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.34,
          dosis_max: 0.34,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Cignus',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'ISK Biosciences',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 822,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.phenylpyridinylamine',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.fluazinam',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_white_mold',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.75,
          dosis_max: 1,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Cintur\u00e3o 500 SC',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'AllierBrasil Agro',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 874,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.benzimidazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.carbendazim',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_anthracnosis',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_target_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Claque',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Tradecorp do Brasil Com\u00e9rcio de insumos Agr\u00edcolas',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.soluble_concentrate_sl',
    pesticide_id: 733,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.cyproconazole',
        active_ingredient_concentration: 100,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.3,
          dosis_max: 0.3,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Cleaner Xtra',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Rainbow',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.dispersible_granules_wg',
    pesticide_id: 677,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.isophthalonitrile',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.chlorothalonil',
        active_ingredient_concentration: 850,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 1.35,
          dosis_max: 2,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 1.35,
          dosis_max: 2,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Clorotalonil Nortox',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Nortox',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 734,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.isophthalonitrile',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.chlorothalonil',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 1.5,
          dosis_max: 3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2,
          dosis_max: 3,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Clorotalonil R 720 SC PERTERRA',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Rainbow',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 875,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.isophthalonitrile',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.chlorothalonil',
        active_ingredient_concentration: 720,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 1.4,
          dosis_max: 1.8,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 1.5,
          dosis_max: 2,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Comet',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Basf',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.emulsifiable_concentrate_ec',
    pesticide_id: 107,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.strobilurin',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.pyraclostrobin',
        active_ingredient_concentration: 250,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.3,
          dosis_max: 0.3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.3,
          dosis_max: 0.3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.3,
          dosis_max: 0.3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_target_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.3,
          dosis_max: 0.3,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Comprenil Mixx',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Rainbow',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.dispersible_granules_wg',
    pesticide_id: 1144,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.isophthalonitrile',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.chlorothalonil',
        active_ingredient_concentration: 600,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
      {
        chemical_group: 'chemical_group.strobilurin',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.trifloxystrobin',
        active_ingredient_concentration: 80,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.cyproconazole',
        active_ingredient_concentration: 40,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 1,
          dosis_max: 1,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Concreto',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'UPL',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 109,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.benzimidazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.carbendazim',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Condor 200 SC',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Sumitomo Chemical',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 563,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.bromuconazole',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.25,
          dosis_max: 0.3,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Congregga',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Genica Inova\u00e7\u00e3o Biotecnologica',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.wettable_powder_wp',
    pesticide_id: 823,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.trichoderma_asperellum',
        active_ingredient_concentration: 30,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_white_mold',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 1.25,
          dosis_max: 1.25,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Constant',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Bayer',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.emulsifiable_concentrate_ec',
    pesticide_id: 113,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.tebuconazole',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.75,
          dosis_max: 0.75,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.75,
          dosis_max: 0.75,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Controller NT',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Dow AgroSciences',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.wettable_powder_wp',
    pesticide_id: 678,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.dithiocarbamate',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.mancozeb',
        active_ingredient_concentration: 800,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 1.5,
          dosis_max: 3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_target_spot',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 1,
          dosis_max: 2,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Convicto',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Adama',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 544,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.strobilurin',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.azoxystrobin',
        active_ingredient_concentration: 100,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.epoxiconazole',
        active_ingredient_concentration: 100,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.6,
          dosis_max: 0.6,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.6,
          dosis_max: 0.6,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.6,
          dosis_max: 0.6,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Copsuper',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Oxiqu\u00edmica Agroci\u00eancia',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 115,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.inorganic',
        mode_of_action:
          'pesticide_mode_of_action.inorganic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.copper_oxychloride',
        active_ingredient_concentration: 588,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 1.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 1.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.25,
          dosis_max: 1.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Cosavet',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'SM Agrocare',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.dispersible_granules_wg',
    pesticide_id: 764,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.inorganic',
        mode_of_action:
          'pesticide_mode_of_action.inorganic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.sulfur',
        active_ingredient_concentration: 800,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 2.5,
          dosis_max: 2.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Covinex 700',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Tradecorp do Brasil Com\u00e9rcio de insumos Agr\u00edcolas',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 735,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.inorganic',
        mode_of_action:
          'pesticide_mode_of_action.inorganic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.copper_oxychloride',
        active_ingredient_concentration: 1196.8,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.7,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.25,
          dosis_max: 0.75,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Cronnos',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Adama',
    pesticide_unit: 'product_unit_measure.l',
    formulation:
      'pesticide_formulation.oil_dispersion_or_oil_concentrated_suspension_od',
    pesticide_id: 117,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.dithiocarbamate',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.mancozeb',
        active_ingredient_concentration: 400,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.strobilurin',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.picoxystrobin',
        active_ingredient_concentration: 26.66,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.tebuconazole',
        active_ingredient_concentration: 33.33,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2.5,
          dosis_max: 3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2,
          dosis_max: 2.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Cropper',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Adama',
    pesticide_unit: 'product_unit_measure.l',
    formulation:
      'pesticide_formulation.oil_dispersion_or_oil_concentrated_suspension_od',
    pesticide_id: 876,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.carboxamide',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.fluxapyroxad',
        active_ingredient_concentration: 22.5,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.dithiocarbamate',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.mancozeb',
        active_ingredient_concentration: 440,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazolinthione',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.prothioconazole',
        active_ingredient_concentration: 31.5,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2.25,
          dosis_max: 2.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Cropshield',
    agronomic_category: 'control_method.chemical',
    asset_owner:
      'Syncrom Assessoria e Com\u00e9rcio de Produtos Agropecu\u00e1rios',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.dispersible_granules_wg',
    pesticide_id: 943,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.isophthalonitrile',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.chlorothalonil',
        active_ingredient_concentration: 825,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 0.8,
          dosis_max: 1.1,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Cuprital 700',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Tradecorp do Brasil Com\u00e9rcio de insumos Agr\u00edcolas',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 679,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.inorganic',
        mode_of_action:
          'pesticide_mode_of_action.inorganic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.copper_oxychloride',
        active_ingredient_concentration: 1196.8,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.7,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.25,
          dosis_max: 0.75,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Cuprodil WG',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Sipcam',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.dispersible_granules_wg',
    pesticide_id: 122,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.inorganic',
        mode_of_action:
          'pesticide_mode_of_action.inorganic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.copper_oxychloride',
        active_ingredient_concentration: 420,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
      {
        chemical_group: 'chemical_group.isophthalonitrile',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.chlorothalonil',
        active_ingredient_concentration: 400,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 1.5,
          dosis_max: 2,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 1.25,
          dosis_max: 1.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 1.25,
          dosis_max: 1.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Cupronil',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Funguran Giulini',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.wettable_powder_wp',
    pesticide_id: 877,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.inorganic',
        mode_of_action:
          'pesticide_mode_of_action.inorganic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.copper_oxychloride',
        active_ingredient_concentration: 588,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 0.5,
          dosis_max: 1.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Curado',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Sumitomo Chemical',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 824,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.phenylpyridinylamine',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.fluazinam',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_white_mold',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.75,
          dosis_max: 1,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Curatis',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Indofil Industries',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1128,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.dithiocarbamate',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.mancozeb',
        active_ingredient_concentration: 413,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.strobilurin',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.picoxystrobin',
        active_ingredient_concentration: 33,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazolinthione',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.prothioconazole',
        active_ingredient_concentration: 29,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2,
          dosis_max: 3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2.5,
          dosis_max: 3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2.5,
          dosis_max: 3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_target_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 2,
          dosis_max: 3,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Curygen EC',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Avgust Crop Protection',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.emulsifiable_concentrate_ec',
    pesticide_id: 577,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.difenoconazole',
        active_ingredient_concentration: 250,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_anthracnosis',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.3,
          dosis_max: 0.3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.15,
          dosis_max: 0.2,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.15,
          dosis_max: 0.15,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.15,
          dosis_max: 0.2,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Cypress 400 EC',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Syngenta',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.emulsifiable_concentrate_ec',
    pesticide_id: 132,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.cyproconazole',
        active_ingredient_concentration: 150,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.difenoconazole',
        active_ingredient_concentration: 250,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.3,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.2,
          dosis_max: 0.3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.2,
          dosis_max: 0.3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.2,
          dosis_max: 0.3,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Czar',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Adama',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 133,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.benzimidazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.carbendazim',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Dart',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Adama',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.emulsifiable_concentrate_ec',
    pesticide_id: 878,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.strobilurin',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.picoxystrobin',
        active_ingredient_concentration: 120,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.tebuconazole',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_asian_soybean_rust',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.5,
          dosis_max: 0.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Dazin',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Pilarquim BR Comercial',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 879,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.isophthalonitrile',
        mode_of_action: 'pesticide_mode_of_action.organic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.chlorothalonil',
        active_ingredient_concentration: 720,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 1.5,
          dosis_max: 2,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Defend WDG',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Quimetal Produtos Quimicos',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.dispersible_granules_wg',
    pesticide_id: 565,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.inorganic',
        mode_of_action:
          'pesticide_mode_of_action.inorganic_multi_site_fungicide',
        active_ingredient: 'active_ingredient.sulfur',
        active_ingredient_concentration: 800,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.kg',
          dosis_min: 2,
          dosis_max: 3,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    crop: 'crop.soybean',
    pesticide: 'Difcor 250 EC',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Gowan Company',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.emulsifiable_concentrate_ec',
    pesticide_id: 148,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.triazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.difenoconazole',
        active_ingredient_concentration: 250,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_anthracnosis',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.3,
          dosis_max: 0.3,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_cercospora_blight',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.15,
          dosis_max: 0.2,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_powdery_mildew',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.15,
          dosis_max: 0.15,
        },
        {
          operation_type: 'operation_type.aerial_spray',
          target: 'soybean_septoria_leaf_spot',
          dosis_unit: 'product_unit_measure.l',
          dosis_min: 0.15,
          dosis_max: 0.2,
        },
      ],
    ],
  },
]

const catalogNematicides = [
  {
    country: 'Brasil',
    pesticide: 'Abamectin Nortox 400 WG',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Nortox',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.dispersible_granules_wg',
    pesticide_id: 1061,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.avermectin',
        mode_of_action:
          'pesticide_mode_of_action.contact_and_ingestion_insecticide',
        active_ingredient: 'active_ingredient.abamectin',
        active_ingredient_concentration: 400,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.kg_ha',
          dosis_min: 1.5,
          dosis_max: 1.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Abamex',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Sumitomo Chemical',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.emulsifiable_concentrate_ec',
    pesticide_id: 1070,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.avermectin',
        mode_of_action:
          'pesticide_mode_of_action.contact_and_ingestion_insecticide',
        active_ingredient: 'active_ingredient.abamectin',
        active_ingredient_concentration: 18,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.l_100_kg_de_semente',
          dosis_min: 0.1,
          dosis_max: 0.125,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Andril Prime',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Basf',
    pesticide_unit: 'product_unit_measure.l',
    formulation:
      'pesticide_formulation.concentrated_suspension_for_seed_treatment_fs',
    pesticide_id: 1043,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_firmus',
        active_ingredient_concentration: 240,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.l_100_kg_de_semente',
          dosis_min: 0.07,
          dosis_max: 0.56,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Atialy',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Agrobiol\u00f3gica Sustentabilidade',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.soluble_concentrate_sl',
    pesticide_id: 1047,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.paecilomyces_lilacinus',
        active_ingredient_concentration: 7,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 1,
          dosis_max: 4,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Augory',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Syngenta',
    pesticide_unit: 'product_unit_measure.l',
    formulation:
      'pesticide_formulation.concentrated_suspension_for_seed_treatment_fs',
    pesticide_id: 1080,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.avermectin',
        mode_of_action:
          'pesticide_mode_of_action.contact_and_ingestion_insecticide',
        active_ingredient: 'active_ingredient.abamectin',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.l_100_kg_de_semente',
          dosis_min: 0.1,
          dosis_max: 0.125,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Aveo EZ',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Sumitomo Chemical',
    pesticide_unit: 'product_unit_measure.l',
    formulation:
      'pesticide_formulation.concentrated_suspension_for_seed_treatment_fs',
    pesticide_id: 1033,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_amyloliquefaciens',
        active_ingredient_concentration: 270,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.ml_ha',
          dosis_min: 3.6,
          dosis_max: 10,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Avicta 500 FS',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Syngenta',
    pesticide_unit: 'product_unit_measure.l',
    formulation:
      'pesticide_formulation.concentrated_suspension_for_seed_treatment_fs',
    pesticide_id: 1055,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.avermectin',
        mode_of_action:
          'pesticide_mode_of_action.contact_and_ingestion_insecticide',
        active_ingredient: 'active_ingredient.abamectin',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.l_100_kg_de_semente',
          dosis_min: 0.1,
          dosis_max: 0.125,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Avicta 500 FS Pro',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Syngenta',
    pesticide_unit: 'product_unit_measure.l',
    formulation:
      'pesticide_formulation.concentrated_suspension_for_seed_treatment_fs',
    pesticide_id: 1052,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.avermectin',
        mode_of_action:
          'pesticide_mode_of_action.contact_and_ingestion_insecticide',
        active_ingredient: 'active_ingredient.abamectin',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.l_100_kg_de_semente',
          dosis_min: 0.1,
          dosis_max: 0.125,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Azir',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Adama',
    pesticide_unit: 'product_unit_measure.l',
    formulation:
      'pesticide_formulation.encapsulated_suspension_for_seed_treatment_cf',
    pesticide_id: 1109,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.fluoroalkenyl',
        mode_of_action: 'pesticide_mode_of_action.systemic_nematicide',
        active_ingredient: 'active_ingredient.fluensulfona',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.l_100_kg_de_semente',
          dosis_min: 0.125,
          dosis_max: 0.25,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Baci-Attack',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Vittia',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1065,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_subtilis',
        active_ingredient_concentration: 7,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 1,
          dosis_max: 6,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Baci-Guard',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Vittia',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1101,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_subtilis',
        active_ingredient_concentration: 7,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 1,
          dosis_max: 6,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Biobac',
    agronomic_category: 'control_method.biological',
    asset_owner: 'UPL',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.wettable_powder_wp',
    pesticide_id: 1092,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_subtilis',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.kg_ha',
          dosis_min: 2,
          dosis_max: 4,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Biobaci',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Vittia',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1117,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_subtilis',
        active_ingredient_concentration: 7,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 1,
          dosis_max: 6,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Boneville',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Koppert do Brasil Holding',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.wettable_powder_wp',
    pesticide_id: 1059,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_amyloliquefaciens',
        active_ingredient_concentration: 50,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.kg_100_kg_de_semente',
          dosis_min: 0.03,
          dosis_max: 0.4,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Captor',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'ALTA - America Latina Tecnologia Agr\u00edcola',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1118,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.oxime_methylcarbamate',
        mode_of_action:
          'pesticide_mode_of_action.systemic_and_contact_insecticide',
        active_ingredient: 'active_ingredient.thiodicarb',
        active_ingredient_concentration: 350,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 0.8,
          dosis_max: 1,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Certeza N',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Iharabras',
    pesticide_unit: 'product_unit_measure.l',
    formulation:
      'pesticide_formulation.concentrated_suspension_for_seed_treatment_fs',
    pesticide_id: 1037,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.benzimidazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.thiophanate_methyl',
        active_ingredient_concentration: 350,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.phenylpyridinylamine',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.fluazinam',
        active_ingredient_concentration: 52.5,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.l_100_kg_de_semente',
          dosis_min: 0.18,
          dosis_max: 0.215,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Chevelle',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Koppert do Brasil Holding',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.wettable_powder_wp',
    pesticide_id: 1077,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_amyloliquefaciens',
        active_ingredient_concentration: 50,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.kg_100_kg_de_semente',
          dosis_min: 0.03,
          dosis_max: 0.4,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Clariva PN',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Syngenta',
    pesticide_unit: 'product_unit_measure.l',
    formulation:
      'pesticide_formulation.concentrated_suspension_for_seed_treatment_fs',
    pesticide_id: 1105,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.pasteuria_nishizawae',
        active_ingredient_concentration: 156,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.l_100_kg_de_semente',
          dosis_min: 0.15,
          dosis_max: 0.45,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Counter 150 G',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'AMVAC',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.granules_gr',
    pesticide_id: 1075,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.organophosphate',
        mode_of_action:
          'pesticide_mode_of_action.contact_and_ingestion_insecticide',
        active_ingredient: 'active_ingredient.terbufos',
        active_ingredient_concentration: 150,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.kg_ha',
          dosis_min: 10,
          dosis_max: 20,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Cropstar',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Bayer',
    pesticide_unit: 'product_unit_measure.l',
    formulation:
      'pesticide_formulation.concentrated_suspension_for_seed_treatment_fs',
    pesticide_id: 1079,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.neonicotinoid',
        mode_of_action: 'pesticide_mode_of_action.systemic_insecticide',
        active_ingredient: 'active_ingredient.imidacloprid',
        active_ingredient_concentration: 150,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.oxime_methylcarbamate',
        mode_of_action:
          'pesticide_mode_of_action.systemic_and_contact_insecticide',
        active_ingredient: 'active_ingredient.thiodicarb',
        active_ingredient_concentration: 450,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.l_100_kg_de_semente',
          dosis_min: 0.5,
          dosis_max: 0.7,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Daytona',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Koppert do Brasil Holding',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 825,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.trichoderma_harzianum',
        active_ingredient_concentration: 48,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 1,
          dosis_max: 1,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Eficaz Nema',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Yesbiose',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1081,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_amyloliquefaciens',
        active_ingredient_concentration: 30,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.l_100_kg_de_semente',
          dosis_min: 0.2,
          dosis_max: 0.3,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Firmeza N',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Iharabras',
    pesticide_unit: 'product_unit_measure.l',
    formulation:
      'pesticide_formulation.concentrated_suspension_for_seed_treatment_fs',
    pesticide_id: 1098,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.benzimidazole',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.thiophanate_methyl',
        active_ingredient_concentration: 350,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
      {
        chemical_group: 'chemical_group.phenylpyridinylamine',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.fluazinam',
        active_ingredient_concentration: 52.5,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.l_100_kg_de_semente',
          dosis_min: 0.18,
          dosis_max: 0.215,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Fortmax',
    agronomic_category: 'control_method.biological',
    asset_owner: 'FMC',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.powder_for_pasting_in_water_ws',
    pesticide_id: 1064,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_licheniformis',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_subtilis',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.kg_100_kg_de_semente',
          dosis_min: 0.1,
          dosis_max: 0.15,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Furatrop',
    agronomic_category: 'control_method.biological',
    asset_owner:
      'Biotrop Solu\u00e7\u00f5es Biol\u00f3gicas e Participa\u00e7\u00f5es',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 886,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_subtilis',
        active_ingredient_concentration: 550,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 0.1,
          dosis_max: 1.2,
        },
      ],
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 0.05,
          dosis_max: 0.8,
        },
      ],
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.l_50_kg_de_semente',
          dosis_min: 0.05,
          dosis_max: 0.5,
        },
      ],
      [
        {
          operation_type: 'operation_type.spray_on_bare_ground',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 0.1,
          dosis_max: 1.2,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Ilevo',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Basf',
    pesticide_unit: 'product_unit_measure.l',
    formulation:
      'pesticide_formulation.concentrated_suspension_for_seed_treatment_fs',
    pesticide_id: 1108,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.carboxamide',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.fluopyram',
        active_ingredient_concentration: 600,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.l_100_kg_de_semente',
          dosis_min: 0.1,
          dosis_max: 0.2,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Inlayon',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Yesbiose',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1085,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_amyloliquefaciens',
        active_ingredient_concentration: 30,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 0.1,
          dosis_max: 0.25,
        },
      ],
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.l_100_kg_de_semente',
          dosis_min: 0.2,
          dosis_max: 0.3,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Inlayon Eco',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Yesbiose',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1039,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_amyloliquefaciens',
        active_ingredient_concentration: 983,
        active_ingredient_unit: 'product_unit_measure.ml_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 0.4,
          dosis_max: 1,
        },
      ],
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.ml_kg_de_semente',
          dosis_min: 2,
          dosis_max: 3,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Lalnix Resist',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Lallemand Solu\u00e7\u00f5es Agrobiol\u00f3gicas',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.dispersible_granules_wg',
    pesticide_id: 1035,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.trichoderma_endophyticum',
        active_ingredient_concentration: 100,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.g_kg_de_semente',
          dosis_min: 1.5,
          dosis_max: 2,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Lilatrix',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Agrobiol\u00f3gica Sustentabilidade',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.soluble_concentrate_sl',
    pesticide_id: 1096,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.paecilomyces_lilacinus',
        active_ingredient_concentration: 7,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 1,
          dosis_max: 4,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Loyalty Bio',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Sumitomo Chemical',
    pesticide_unit: 'product_unit_measure.l',
    formulation:
      'pesticide_formulation.concentrated_suspension_for_seed_treatment_fs',
    pesticide_id: 1056,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_amyloliquefaciens',
        active_ingredient_concentration: 10,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.ml_100_kg_de_semente',
          dosis_min: 60,
          dosis_max: 80,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Lumialza',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Sumitomo Chemical',
    pesticide_unit: 'product_unit_measure.l',
    formulation:
      'pesticide_formulation.concentrated_suspension_for_seed_treatment_fs',
    pesticide_id: 1119,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_amyloliquefaciens',
        active_ingredient_concentration: 270,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.ml_ha',
          dosis_min: 3.6,
          dosis_max: 10,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Mantis 400 WG',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Cropchem',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.dispersible_granules_wg',
    pesticide_id: 1068,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.avermectin',
        mode_of_action:
          'pesticide_mode_of_action.contact_and_ingestion_insecticide',
        active_ingredient: 'active_ingredient.abamectin',
        active_ingredient_concentration: 400,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.kg_ha',
          dosis_min: 1.5,
          dosis_max: 1.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Nema-attack',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Vittia',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1082,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_amyloliquefaciens',
        active_ingredient_concentration: 42,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 0.15,
          dosis_max: 1,
        },
      ],
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 0.5,
          dosis_max: 4,
        },
      ],
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.ml_kg_de_semente',
          dosis_min: 0.5,
          dosis_max: 4,
        },
      ],
      [
        {
          operation_type: 'operation_type.spray_on_bare_ground',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 0.15,
          dosis_max: 1,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Nema-guard',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Vittia',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1121,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_amyloliquefaciens',
        active_ingredient_concentration: 42,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 0.15,
          dosis_max: 1,
        },
      ],
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 0.5,
          dosis_max: 4,
        },
      ],
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.ml_kg_de_semente',
          dosis_min: 0.5,
          dosis_max: 4,
        },
      ],
      [
        {
          operation_type: 'operation_type.spray_on_bare_ground',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 0.15,
          dosis_max: 1,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Nemacontrol',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Yesbiose',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1044,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_amyloliquefaciens',
        active_ingredient_concentration: 30,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 0.1,
          dosis_max: 0.25,
        },
      ],
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.l_100_kg_de_semente',
          dosis_min: 0.2,
          dosis_max: 0.3,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Nemacontrol Super',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Yesbiose',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1111,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_amyloliquefaciens',
        active_ingredient_concentration: 983,
        active_ingredient_unit: 'product_unit_measure.ml_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 0.4,
          dosis_max: 1,
        },
      ],
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.ml_kg_de_semente',
          dosis_min: 2,
          dosis_max: 3,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Nemakill',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Agrobiol\u00f3gica Sustentabilidade',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.soluble_concentrate_sl',
    pesticide_id: 1060,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.paecilomyces_lilacinus',
        active_ingredient_concentration: 7,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 1,
          dosis_max: 4,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Nemat',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Ballagro Agro Tecnologia',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.wettable_powder_wp',
    pesticide_id: 1099,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.paecilomyces_lilacinus',
        active_ingredient_concentration: 300,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.kg_ha',
          dosis_min: 0.1,
          dosis_max: 0.6,
        },
      ],
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.kg_100_kg_de_semente',
          dosis_min: 0.1,
          dosis_max: 0.25,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Nematrop',
    agronomic_category: 'control_method.biological',
    asset_owner:
      'Biotrop Solu\u00e7\u00f5es Biol\u00f3gicas e Participa\u00e7\u00f5es',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1106,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_subtilis',
        active_ingredient_concentration: 550,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 0.1,
          dosis_max: 1.2,
        },
      ],
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 0.05,
          dosis_max: 0.8,
        },
      ],
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.l_50_kg_de_semente',
          dosis_min: 0.05,
          dosis_max: 0.5,
        },
      ],
      [
        {
          operation_type: 'operation_type.spray_on_bare_ground',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 0.1,
          dosis_max: 1.2,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Nettus',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Ballagro Agro Tecnologia',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.wettable_powder_wp',
    pesticide_id: 1120,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.paecilomyces_lilacinus',
        active_ingredient_concentration: 300,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          dosis_unit: 'product_unit_measure.kg_ha',
          dosis_min: 1.92,
          dosis_max: 1.92,
        },
      ],
      [
        {
          operation_type: 'operation_type.spray_on_bare_ground',
          dosis_unit: 'product_unit_measure.kg_ha',
          dosis_min: 1.92,
          dosis_max: 1.92,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Nimitz TS',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Adama',
    pesticide_unit: 'product_unit_measure.l',
    formulation:
      'pesticide_formulation.encapsulated_suspension_for_seed_treatment_cf',
    pesticide_id: 1062,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.fluoroalkenyl',
        mode_of_action: 'pesticide_mode_of_action.systemic_nematicide',
        active_ingredient: 'active_ingredient.fluensulfona',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.l_100_kg_de_semente',
          dosis_min: 0.05,
          dosis_max: 0.1,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'No-nema',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Vittia',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1049,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_amyloliquefaciens',
        active_ingredient_concentration: 42,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 0.15,
          dosis_max: 1,
        },
      ],
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 0.5,
          dosis_max: 4,
        },
      ],
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.ml_kg_de_semente',
          dosis_min: 0.5,
          dosis_max: 4,
        },
      ],
      [
        {
          operation_type: 'operation_type.spray_on_bare_ground',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 0.15,
          dosis_max: 1,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Oleaje Prime',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Basf',
    pesticide_unit: 'product_unit_measure.l',
    formulation:
      'pesticide_formulation.concentrated_suspension_for_seed_treatment_fs',
    pesticide_id: 1038,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_firmus',
        active_ingredient_concentration: 240,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.l_100_kg_de_semente',
          dosis_min: 0.07,
          dosis_max: 0.56,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Onix',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Lallemand Solu\u00e7\u00f5es Agrobiol\u00f3gicas',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1045,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_methylotrophicus',
        active_ingredient_concentration: 15,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 6,
          dosis_max: 6,
        },
      ],
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.ml_kg_de_semente',
          dosis_min: 3,
          dosis_max: 3,
        },
      ],
      [
        {
          operation_type: 'operation_type.spray_on_bare_ground',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 6,
          dosis_max: 6,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Onix OG',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Lallemand Solu\u00e7\u00f5es Agrobiol\u00f3gicas',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1076,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_methylotrophicus',
        active_ingredient_concentration: 15,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 6,
          dosis_max: 6,
        },
      ],
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.ml_kg_de_semente',
          dosis_min: 3,
          dosis_max: 3,
        },
      ],
      [
        {
          operation_type: 'operation_type.spray_on_bare_ground',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 6,
          dosis_max: 6,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'PC-Attack',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Vittia',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1073,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.pochonia_chlamydosporia',
        active_ingredient_concentration: 0.1,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 0.5,
          dosis_max: 4,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'PC-Guard',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Vittia',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1086,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.pochonia_chlamydosporia',
        active_ingredient_concentration: 0.1,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 0.5,
          dosis_max: 4,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Pontiac 350 SC',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Rotam do Brasil Agroqu\u00edmica e Produtos Agr\u00edcolas',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1083,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.oxime_methylcarbamate',
        mode_of_action:
          'pesticide_mode_of_action.systemic_and_contact_insecticide',
        active_ingredient: 'active_ingredient.thiodicarb',
        active_ingredient_concentration: 350,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.l_100_kg_de_semente',
          dosis_min: 0.8,
          dosis_max: 0.8,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Presence',
    agronomic_category: 'control_method.biological',
    asset_owner: 'FMC',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.powder_for_pasting_in_water_ws',
    pesticide_id: 1048,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_licheniformis',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_subtilis',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.kg_100_kg_de_semente',
          dosis_min: 0.1,
          dosis_max: 0.15,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Profix',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Agrivalle Brasil Industria e Comercio de Produtos Agricolas',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.wettable_powder_wp',
    pesticide_id: 1115,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_licheniformis',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_subtilis',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.paecilomyces_lilacinus',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.g_ha',
          dosis_min: 50,
          dosis_max: 250,
        },
      ],
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.g_100_kg_de_semente',
          dosis_min: 90,
          dosis_max: 200,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Promobio',
    agronomic_category: 'control_method.biological',
    asset_owner:
      'Biotrop Solu\u00e7\u00f5es Biol\u00f3gicas e Participa\u00e7\u00f5es',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1091,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_subtilis',
        active_ingredient_concentration: 550,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 0.1,
          dosis_max: 0.2,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Quartzo',
    agronomic_category: 'control_method.biological',
    asset_owner: 'FMC',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.powder_for_pasting_in_water_ws',
    pesticide_id: 1069,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_licheniformis',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_subtilis',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.kg_ha',
          dosis_min: 0.12,
          dosis_max: 0.3,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Rizo-Turbo',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Vittia',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1088,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.pochonia_chlamydosporia',
        active_ingredient_concentration: 0.1,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 0.5,
          dosis_max: 4,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Rizos',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Lallemand Solu\u00e7\u00f5es Agrobiol\u00f3gicas',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1094,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_subtilis',
        active_ingredient_concentration: 15,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 4,
          dosis_max: 8,
        },
      ],
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.ml_kg_de_semente',
          dosis_min: 2,
          dosis_max: 4,
        },
      ],
      [
        {
          operation_type: 'operation_type.spray_on_bare_ground',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 4,
          dosis_max: 8,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Rizos OG',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Lallemand Solu\u00e7\u00f5es Agrobiol\u00f3gicas',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1058,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_subtilis',
        active_ingredient_concentration: 15,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 4,
          dosis_max: 8,
        },
      ],
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.ml_kg_de_semente',
          dosis_min: 2,
          dosis_max: 4,
        },
      ],
      [
        {
          operation_type: 'operation_type.spray_on_bare_ground',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 4,
          dosis_max: 8,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Rizotec',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Rizoflora Biotecnologia',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.wettable_powder_wp',
    pesticide_id: 1116,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.pochonia_chlamydosporia',
        active_ingredient_concentration: 280,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.kg_ha',
          dosis_min: 1,
          dosis_max: 3,
        },
      ],
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.g_ha',
          dosis_min: 100,
          dosis_max: 250,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Rizotec Crops',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Rizoflora Biotecnologia',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.wettable_powder_wp',
    pesticide_id: 1053,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.pochonia_chlamydosporia',
        active_ingredient_concentration: 280,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.kg_ha',
          dosis_min: 1,
          dosis_max: 3,
        },
      ],
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.g_ha',
          dosis_min: 100,
          dosis_max: 250,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Rugby 100 GR',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'FMC',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.granules_gr',
    pesticide_id: 1036,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.organophosphate',
        mode_of_action:
          'pesticide_mode_of_action.contact_and_ingestion_insecticide',
        active_ingredient: 'active_ingredient.cadusafos',
        active_ingredient_concentration: 100,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.kg_ha',
          dosis_min: 8,
          dosis_max: 8,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Rugby 200 CS',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'FMC',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.encapsulated_suspension_cs',
    pesticide_id: 1102,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.organophosphate',
        mode_of_action:
          'pesticide_mode_of_action.contact_and_ingestion_insecticide',
        active_ingredient: 'active_ingredient.cadusafos',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 4,
          dosis_max: 4,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Saddler 350 SC',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Rotam do Brasil Agroqu\u00edmica e Produtos Agr\u00edcolas',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1112,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.oxime_methylcarbamate',
        mode_of_action:
          'pesticide_mode_of_action.systemic_and_contact_insecticide',
        active_ingredient: 'active_ingredient.thiodicarb',
        active_ingredient_concentration: 350,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.l_100_kg_de_semente',
          dosis_min: 0.8,
          dosis_max: 0.8,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Surface',
    agronomic_category: 'control_method.biological',
    asset_owner: 'FMC',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.powder_for_pasting_in_water_ws',
    pesticide_id: 1087,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_licheniformis',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_subtilis',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.kg_ha',
          dosis_min: 0.12,
          dosis_max: 0.3,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Tacap',
    agronomic_category: 'control_method.biological',
    asset_owner: 'UPL',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.wettable_powder_wp',
    pesticide_id: 1110,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_subtilis',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.kg_ha',
          dosis_min: 2,
          dosis_max: 4,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Trianum DS',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Koppert do Brasil Holding',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.dispersible_granules_wg',
    pesticide_id: 1040,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.trichoderma_harzianum',
        active_ingredient_concentration: 10,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.kg_100_kg_de_semente',
          dosis_min: 0.2,
          dosis_max: 0.3,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Trichodermil SC 1306',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Koppert do Brasil Holding',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1093,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.trichoderma_harzianum',
        active_ingredient_concentration: 48,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 1,
          dosis_max: 1,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Trichodermil Super SC 1306',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Koppert do Brasil Holding',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1104,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.trichoderma_harzianum',
        active_ingredient_concentration: 48,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 1,
          dosis_max: 1,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Trunemco',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Sumitomo Chemical',
    pesticide_unit: 'product_unit_measure.l',
    formulation:
      'pesticide_formulation.concentrated_suspension_for_seed_treatment_fs',
    pesticide_id: 1054,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_amyloliquefaciens',
        active_ingredient_concentration: 10,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.ml_100_kg_de_semente',
          dosis_min: 60,
          dosis_max: 80,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Unique',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Ballagro Agro Tecnologia',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.wettable_powder_wp',
    pesticide_id: 1072,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.paecilomyces_lilacinus',
        active_ingredient_concentration: 300,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.aerial_spray',
          dosis_unit: 'product_unit_measure.kg_ha',
          dosis_min: 1.92,
          dosis_max: 1.92,
        },
      ],
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.kg_ha',
          dosis_min: 1.92,
          dosis_max: 1.92,
        },
      ],
      [
        {
          operation_type: 'operation_type.spray_on_bare_ground',
          dosis_unit: 'product_unit_measure.kg_ha',
          dosis_min: 1.92,
          dosis_max: 1.92,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Veraneio',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Koppert do Brasil Holding',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.wettable_powder_wp',
    pesticide_id: 1122,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_amyloliquefaciens',
        active_ingredient_concentration: 50,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.g_100_kg_de_semente',
          dosis_min: 30,
          dosis_max: 400,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Verango Prime',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Bayer',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1097,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.carboxamide',
        mode_of_action: 'pesticide_mode_of_action.site_specific_fungicide',
        active_ingredient: 'active_ingredient.fluopyram',
        active_ingredient_concentration: 500,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.l_ha',
          dosis_min: 0.3,
          dosis_max: 0.5,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Vigga',
    agronomic_category: 'control_method.chemical',
    asset_owner: 'Omex Agrifluids',
    pesticide_unit: 'product_unit_measure.l',
    formulation: 'pesticide_formulation.concentrated_suspension_sc',
    pesticide_id: 1113,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.plant_extract',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.allium_sativum',
        active_ingredient_concentration: 800,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.l_100_kg_de_semente',
          dosis_min: 0.2,
          dosis_max: 0.4,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Volga Goplan',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Agrivalle Brasil Industria e Comercio de Produtos Agricolas',
    pesticide_unit: 'product_unit_measure.kg',
    formulation: 'pesticide_formulation.wettable_powder_wp',
    pesticide_id: 1071,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_licheniformis',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_subtilis',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.paecilomyces_lilacinus',
        active_ingredient_concentration: 200,
        active_ingredient_unit: 'product_unit_measure.g_kg',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.in_furrow',
          dosis_unit: 'product_unit_measure.g_ha',
          dosis_min: 50,
          dosis_max: 250,
        },
      ],
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.g_100_kg_de_semente',
          dosis_min: 90,
          dosis_max: 200,
        },
      ],
    ],
  },
  {
    country: 'Brasil',
    pesticide: 'Votivo Prime',
    agronomic_category: 'control_method.biological',
    asset_owner: 'Basf',
    pesticide_unit: 'product_unit_measure.l',
    formulation:
      'pesticide_formulation.concentrated_suspension_for_seed_treatment_fs',
    pesticide_id: 1125,
    activeIngredients: [
      {
        chemical_group: 'chemical_group.biological',
        mode_of_action: 'pesticide_mode_of_action.unknown',
        active_ingredient: 'active_ingredient.bacillus_firmus',
        active_ingredient_concentration: 240,
        active_ingredient_unit: 'product_unit_measure.g_l',
      },
    ],
    operations: [
      [
        {
          operation_type: 'operation_type.seed_treatment',
          dosis_unit: 'product_unit_measure.ml_100_kg_de_semente',
          dosis_min: 70,
          dosis_max: 560,
        },
      ],
    ],
  },
]

const catalogVarieties = [
  {
    seed_id: 1227,
    name: '5D6215 IPRO',
    asset_owner: 'Brevant',
    general_info: {
      relative_maturity: '6.4',
      growth_habit: 'growth_habit.indeterminate',
      min_cycle: 130,
      max_cycle: 134,
      rust_tolerant: false,
      min_population: 200,
      max_population: 300,
      start_sowing_format: '20/09',
      end_sowing_format: '31/12',
      ogm: 'Yes',
    },
  },
  {
    seed_id: 263,
    name: '5D634 RR',
    asset_owner: 'Dow AgroSciences',
    general_info: {
      relative_maturity: '6.3',
      growth_habit: 'growth_habit.indeterminate',
      min_cycle: 134,
      max_cycle: 138,
      rust_tolerant: false,
      min_population: 220,
      max_population: 300,
      start_sowing_format: '01/10',
      end_sowing_format: '15/12',
      ogm: 'Yes',
    },
  },
  {
    seed_id: 1849,
    name: '95R21 E',
    asset_owner: 'Pioneer',
    general_info: {
      relative_maturity: '5.2',
      growth_habit: 'growth_habit.indeterminate',
      min_cycle: 113,
      max_cycle: 117,
      rust_tolerant: false,
      min_population: 340,
      max_population: 360,
      start_sowing_format: '01/10',
      end_sowing_format: '15/12',
      ogm: 'Yes',
    },
  },
  {
    seed_id: 1343,
    name: '95R30 IPRO',
    asset_owner: 'Pioneer',
    general_info: {
      relative_maturity: '5.0',
      growth_habit: 'growth_habit.indeterminate',
      min_cycle: 121,
      max_cycle: 125,
      rust_tolerant: false,
      min_population: 280,
      max_population: 300,
      start_sowing_format: '20/09',
      end_sowing_format: '10/12',
      ogm: 'Yes',
    },
  },
  {
    seed_id: 1307,
    name: '95R40 IPRO',
    asset_owner: 'Pioneer',
    general_info: {
      relative_maturity: '5.4',
      growth_habit: 'growth_habit.indeterminate',
      min_cycle: 120,
      max_cycle: 124,
      rust_tolerant: false,
      min_population: 250,
      max_population: 350,
      start_sowing_format: '01/10',
      end_sowing_format: '15/12',
      ogm: 'Yes',
    },
  },
  {
    seed_id: 11,
    name: '95R51',
    asset_owner: 'Pioneer',
    general_info: {
      relative_maturity: '5.3',
      growth_habit: 'growth_habit.indeterminate',
      min_cycle: 118,
      max_cycle: 122,
      rust_tolerant: false,
      min_population: 320,
      max_population: 390,
      start_sowing_format: '15/09',
      end_sowing_format: '15/12',
      ogm: 'Yes',
    },
  },
  {
    seed_id: 3332,
    name: '95R70 CE',
    asset_owner: 'Pioneer',
    general_info: {
      relative_maturity: '5.7',
      growth_habit: 'growth_habit.indeterminate',
      min_cycle: 126,
      max_cycle: 130,
      rust_tolerant: false,
      min_population: 220,
      max_population: 260,
      start_sowing_format: '15/09',
      end_sowing_format: '15/12',
      ogm: 'Yes',
    },
  },
  {
    seed_id: 1186,
    name: '95R90 IPRO',
    asset_owner: 'Pioneer',
    general_info: {
      relative_maturity: '5.9',
      growth_habit: 'growth_habit.indeterminate',
      min_cycle: 132,
      max_cycle: 136,
      rust_tolerant: false,
      min_population: 250,
      max_population: 320,
      start_sowing_format: '15/09',
      end_sowing_format: '15/12',
      ogm: 'Yes',
    },
  },
  {
    seed_id: 1187,
    name: '95R95 IPRO',
    asset_owner: 'Pioneer',
    general_info: {
      relative_maturity: '5.9',
      growth_habit: 'growth_habit.indeterminate',
      min_cycle: 132,
      max_cycle: 136,
      rust_tolerant: false,
      min_population: 250,
      max_population: 320,
      start_sowing_format: '15/09',
      end_sowing_format: '15/12',
      ogm: 'Yes',
    },
  },
  {
    seed_id: 1304,
    name: '95Y02 IPRO',
    asset_owner: 'Pioneer',
    general_info: {
      relative_maturity: '4.9',
      growth_habit: 'growth_habit.indeterminate',
      min_cycle: 116,
      max_cycle: 120,
      rust_tolerant: false,
      min_population: 300,
      max_population: 340,
      start_sowing_format: '15/09',
      end_sowing_format: '31/12',
      ogm: 'Yes',
    },
  },
  {
    seed_id: 1847,
    name: '95Y42 IPRO',
    asset_owner: 'Pioneer',
    general_info: {
      relative_maturity: '5.4',
      growth_habit: 'growth_habit.indeterminate',
      min_cycle: 123,
      max_cycle: 127,
      rust_tolerant: false,
      min_population: 260,
      max_population: 300,
      start_sowing_format: '20/10',
      end_sowing_format: '30/11',
      ogm: 'Yes',
    },
  },
  {
    seed_id: 1191,
    name: '95Y52',
    asset_owner: 'Pioneer',
    general_info: {
      relative_maturity: '5.5',
      growth_habit: 'growth_habit.indeterminate',
      min_cycle: 120,
      max_cycle: 124,
      rust_tolerant: false,
      min_population: 340,
      max_population: 370,
      start_sowing_format: '15/09',
      end_sowing_format: '21/12',
      ogm: 'Yes',
    },
  },
  {
    seed_id: 14,
    name: '95Y72',
    asset_owner: 'Pioneer',
    general_info: {
      relative_maturity: '4.9',
      growth_habit: 'growth_habit.indeterminate',
      min_cycle: 118,
      max_cycle: 122,
      rust_tolerant: false,
      min_population: 340,
      max_population: 370,
      start_sowing_format: '15/09',
      end_sowing_format: '15/12',
      ogm: 'Yes',
    },
  },
  {
    seed_id: 1339,
    name: '96R10 IPRO',
    asset_owner: 'Pioneer',
    general_info: {
      relative_maturity: '6.1',
      growth_habit: 'growth_habit.indeterminate',
      min_cycle: 133,
      max_cycle: 137,
      rust_tolerant: false,
      min_population: 190,
      max_population: 210,
      start_sowing_format: '01/10',
      end_sowing_format: '10/12',
      ogm: 'Yes',
    },
  },
  {
    seed_id: 1306,
    name: '96R29 IPRO',
    asset_owner: 'Pioneer',
    general_info: {
      relative_maturity: '6.2',
      growth_habit: 'growth_habit.indeterminate',
      min_cycle: 129,
      max_cycle: 133,
      rust_tolerant: false,
      min_population: 200,
      max_population: 300,
      start_sowing_format: '01/10',
      end_sowing_format: '10/12',
      ogm: 'Yes',
    },
  },
]

export { catalogFungicides, catalogNematicides, catalogVarieties }
